<template>
  <div class="staffPage">
    <div
      class="staff-block"
      @mousemove="changeCursorAnim($event)"
      @click="changeStaffWords"
    >
      <button class="btn-next" ref="btnNext">
        <div class="btn-letter-block" id="topBtnBlockLetter">
          <span
            v-for="(word, index) in staffWords"
            :key="index"
            class="btn-letter"
            :style="`transform:rotate(${index * 16}deg)`"
            >{{ word }}</span
          >
        </div>
        <svg
          viewBox="0 0 69 69"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="btn-arrow"
          :class="{ 'btn-arrow-journalist': !btnJournalist }"
        >
          <g>
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="69"
              height="69"
            >
              <g style="mix-blend-mode:luminosity">
                <rect
                  x="0.782227"
                  y="0.370117"
                  width="68"
                  height="68"
                  fill="url(#pattern0)"
                />
              </g>
            </mask>
            <g mask="url(#mask0)">
              <rect
                x="0.782227"
                y="0.370117"
                width="68"
                height="68"
                fill="#ae9a79"
              />
            </g>
          </g>
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlink:href="#image0" transform="scale(0.00195312)" />
            </pattern>
            <image
              id="image0"
              width="512"
              height="512"
              xlink:href="data:image/png;base64,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"
            />
          </defs>
        </svg>
        <div class="btn-letter-block" id="bottomBtnBlockLetter">
          <span
            v-for="(word, index) in staffWords"
            :key="index"
            class="btn-letter"
            :style="`transform:rotate(${index * 16}deg)`"
            >{{ word }}</span
          >
        </div>
      </button>
      <div
        class="journalist-block"
        :class="{ activeJournalist: !btnJournalist }"
      >
        <div class="journalist-left">
          <span class="journalist-left-text">{{
            $t("staff_page.journalists")
          }}</span>
          <span class="journalist-left-text">Zamon.uz</span>
        </div>
        <div class="journalist-right">
          <div class="journalist-card" v-for="index in 3" :key="index">
            <div class="card-image-block">
              <span class="card-category">{{
                $t("staff_page.news_card.category")
              }}</span>
              <img
                class="card-img"
                src="../assets/staffImage/journalist-1.png"
                alt=""
              />
            </div>
            <div class="card-text-block">
              <span class="card-text">
                {{ $t("staff_page.news_card.title") }}
              </span>
              <span class="card-time">{{
                $t("staff_page.news_card.data")
              }}</span>
            </div>
          </div>
          <div class="journalist-decor-block">
            <svg
              viewBox="0 0 714 937"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="journalist-decor"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M476.435 1.53327C582.292 -7.23716 703.698 20.9242 769.936 103.962C834.068 184.359 769.971 304.538 797.241 403.7C822.392 495.154 926.928 557.654 920.736 652.302C914.12 753.433 851.133 851.843 764.484 904.409C680.179 955.552 574.248 934.31 476.435 921.835C390.431 910.866 313.323 878.742 237.243 837.163C149.223 789.059 18.2435 761.16 1.47546 662.264C-15.841 560.133 124.178 502.027 164.222 406.492C198.813 323.965 161.626 220.701 216.263 149.835C278.742 68.7949 374.457 9.98235 476.435 1.53327Z"
                fill="#45546B"
              />
            </svg>
            <svg
              viewBox="0 0 703 895"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="journalist-decor"
            >
              <g filter="url(#filter0_d)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M464.259 16.4187C562.3 8.3035 674.742 34.361 736.09 111.195C795.487 185.586 736.122 296.787 761.379 388.541C784.673 473.163 881.49 530.994 875.755 618.571C869.628 712.147 811.291 803.205 731.04 851.843C652.959 899.166 554.849 879.511 464.259 867.968C384.605 857.818 313.19 828.094 242.727 789.621C161.205 745.111 39.8965 719.297 24.3665 627.788C8.32861 533.287 138.009 479.522 175.097 391.124C207.134 314.763 172.693 219.213 223.295 153.641C281.162 78.6555 369.81 24.2366 464.259 16.4187Z"
                  fill="#495A74"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d"
                  x="0"
                  y="0"
                  width="881"
                  height="895"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-9" dy="-1" />
                  <feGaussianBlur stdDeviation="7" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
            <svg
              viewBox="0 0 639 773"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="journalist-decor"
            >
              <g filter="url(#filter0_d)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M398.217 13.2256C482.696 6.21491 579.583 28.726 632.444 95.1028C683.625 159.369 632.472 255.436 654.235 334.701C674.307 407.806 757.731 457.766 752.789 533.424C747.509 614.264 697.243 692.929 628.093 734.948C560.814 775.83 476.276 758.85 398.217 748.878C329.582 740.109 268.046 714.431 207.331 681.194C137.087 642.742 32.5592 620.441 19.1775 541.387C5.35818 459.747 117.1 413.3 149.057 336.933C176.662 270.965 146.985 188.419 190.587 131.772C240.449 66.9919 316.834 19.9795 398.217 13.2256Z"
                  fill="#505E75"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d"
                  x="0"
                  y="0"
                  width="759"
                  height="773"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-6" />
                  <feGaussianBlur stdDeviation="6" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
            <svg
              viewBox="0 0 587 667"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="journalist-decor"
            >
              <g filter="url(#filter0_d)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M344.625 4.07181C418.53 -2.05906 503.289 17.6268 549.534 75.6734C594.308 131.874 549.558 215.884 568.597 285.202C586.157 349.132 659.139 392.822 654.816 458.985C650.197 529.68 606.222 598.472 545.728 635.217C486.87 670.969 412.913 656.12 344.625 647.399C284.581 639.731 230.748 617.275 177.632 588.21C116.181 554.583 24.7368 535.081 13.0301 465.948C0.940559 394.555 98.6953 353.937 126.652 287.154C150.802 229.464 124.84 157.279 162.985 107.74C206.605 51.0904 273.429 9.97805 344.625 4.07181Z"
                  fill="#516586"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d"
                  x="0"
                  y="0"
                  width="655"
                  height="667"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-6" dy="3" />
                  <feGaussianBlur stdDeviation="3" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div class="colleagues-block" :class="{ activeCollegues: btnJournalist }">
        <div class="colleagues-left">
          <img
            src="../assets/staffImage/collegues-first.png"
            alt=""
            class="collegues-decor"
          />
          <img
            src="../assets/staffImage/collegues-second.png"
            alt=""
            class="collegues-decor"
          />
          <img
            src="../assets/staffImage/collegues-third.png"
            alt=""
            class="collegues-decor"
          />
          <svg
            viewBox="0 0 618 618"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="collegues-decor"
          >
            <g filter="url(#filter0_d)">
              <rect x="23" y="15" width="590" height="590" fill="#495A74" />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="0"
                width="618"
                height="618"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-9" dy="-1" />
                <feGaussianBlur stdDeviation="7" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
          <svg
            viewBox="0 0 522 522"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="collegues-decor"
          >
            <g filter="url(#filter0_d)">
              <rect x="18" y="12" width="498" height="498" fill="#505E75" />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="0"
                width="522"
                height="522"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-6" />
                <feGaussianBlur stdDeviation="6" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
          <svg
            viewBox="0 0 428 428"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="collegues-decor"
          >
            <g filter="url(#filter0_d)">
              <rect x="12" y="3" width="416" height="416" fill="#516586" />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="0"
                width="428"
                height="428"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-6" dy="3" />
                <feGaussianBlur stdDeviation="3" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div class="colleagues-right">
          <span class="colleagues-right-text">{{
            $t("staff_page.employees")
          }}</span>
          <span class="colleagues-right-text">Zamon.uz</span>
        </div>
      </div>
    </div>
    <Journalist v-if="btnJournalist" />
    <Collegues v-if="!btnJournalist" />
  </div>
</template>
<script>
import { ref } from "vue";
import Journalist from "@/components/staff-team/Journalist.vue";
import Collegues from "@/components/staff-team/Collegues.vue";
import { useLanguage } from "@/utils/language";

export default {
  name: "StaffPage",
  components: { Journalist, Collegues },
  setup() {
    const { i18n } = useLanguage();

    const staffWords = ref(i18n.global.t("staff_page.journalists"));
    // const JournalistWords = "Журналисты";
    const btnNext = ref(true);
    const btnJournalist = ref(true);
    const changeCursorAnim = e => {
      if (typeof window !== "undefined") {
        if (window.innerWidth > 1300) {
          let x, y;
          if (document.all) {
            x = e.x + document.body.scrollLeft;
            y = e.y + document.body.scrollTop;
          } else {
            x = e.pageX;
            y = e.pageY;
          }
          if (window.innerWidth * 0.26 > y) {
            btnNext.value.style.top = `${y - 50}px`;
            btnNext.value.style.left = `${x - 50}px`;
          }
        }
      }
    };
    const changeStaffWords = () => {
      btnJournalist.value = !btnJournalist.value;
      if (!btnJournalist.value) {
        console.log(true);
        staffWords.value = i18n.global.t("staff_page.journalists");
      } else {
        console.log(false);
        staffWords.value = i18n.global.t("staff_page.employees");
      }
    };

    return {
      staffWords,
      btnNext,
      changeStaffWords,
      changeCursorAnim,
      btnJournalist
      // latestNews: computed(() => store.getters.latestNews)
    };
  }
};
</script>
<style lang="css">
@keyframes cardFirst {
  from {
    right: 0;
  }
  to {
    right: 57%;
  }
}
@keyframes cardSecond {
  from {
    right: 0;
  }
  to {
    right: 65%;
  }
}
@keyframes cardThird {
  from {
    right: -15%;
  }
  to {
    right: 36%;
  }
}
@keyframes topBtnBlockLetter {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes bottomBtnBlockLetter {
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(540deg);
  }
}
@media screen and (max-width: 768px) {
  @keyframes cardFirst {
    from {
      right: -50%;
    }
    to {
      right: 28%;
    }
  }
  @keyframes cardSecond {
    from {
      right: -50%;
    }
    to {
      right: 80%;
    }
  }
  @keyframes cardThird {
    from {
      right: -50%;
    }
    to {
      right: 40%;
    }
  }
}
@media screen and (max-width: 375px) {
  @keyframes cardFirst {
    from {
      right: -50%;
    }
    to {
      right: 25%;
    }
  }
  @keyframes cardSecond {
    from {
      right: -50%;
    }
    to {
      right: 100%;
    }
  }
  @keyframes cardThird {
    from {
      right: -50%;
    }
    to {
      right: 40%;
    }
  }
}
</style>
<style lang="scss" scoped>
.staffPage {
  overflow-x: hidden;
  position: relative;
  width: 100%;
  padding-top: calc(var(--header-main-height) + 3.5rem);
  padding-bottom: 2rem;
  background: linear-gradient(360deg, #536976 0%, #292e49 100%);
  .staff-block {
    .btn-next {
      z-index: 9;
      background: inherit;
      position: absolute;
      width: 8vw;
      height: 8vw;
      border-radius: 50%;
      cursor: none;
      transform: rotate(180deg);
      .btn-arrow {
        width: 65%;
        height: 65%;
        transition: all 0.3s;
      }
      .btn-arrow-journalist {
        transform: rotate(180deg);
      }
      .btn-letter-block {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        animation-duration: 5s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        &:nth-child(1) {
          animation-name: topBtnBlockLetter;
        }
        &:nth-child(3) {
          animation-name: bottomBtnBlockLetter;
        }
      }
      .btn-letter {
        position: absolute;
        left: 50%;
        bottom: 50%;
        width: 0;
        transform-origin: 0 100%;
        padding-bottom: 60px;
        color: #c2b5a0;
        font-size: 24px;
      }
    }
    .activeJournalist {
      transform: translateX(100%);
    }
    .activeCollegues {
      transform: translateX(-100%);
    }
    .journalist-block {
      position: absolute;
      width: 100%;
      height: 25vw;
      display: flex;
      transition: all 1.5s;

      .journalist-left {
        position: relative;
        width: 50%;
        color: #98a2b7;
        margin: auto 0;
        .journalist-left-text {
          position: relative;
          display: block;
          &:nth-child(1) {
            text-align: center;
            font-size: 4.68vw;
            line-height: 1.35;
            font-family: "Open Sans";
            font-style: normal;
            font-weight: 600;
          }
          &:nth-child(2) {
            font-family: "Playfair Display SC";
            font-style: normal;
            font-weight: bold;
            font-size: 3.9vw;
            line-height: 1.25;
            color: #98a2b7;
            text-align: end;
          }
        }
      }
      .journalist-right {
        position: relative;
        width: 50%;
        margin: 0 0 0 auto;
        .journalist-card {
          position: absolute;
          animation-duration: 1s;
          animation-fill-mode: forwards;
          .card-image-block {
            position: relative;
            border-radius: 9px;
            overflow: hidden;
            .card-category {
              display: inline-block;
              position: absolute;
              font-family: Open Sans;
              font-style: normal;
              font-weight: normal;
              line-height: 1.36;
              color: rgba(255, 255, 255, 0.7);
              background: #303851;
              padding: 2px 5px;
              z-index: 1;
            }
            .card-img {
              position: relative;
              border-radius: 9px;
              width: 100%;
            }
          }
          .card-text-block {
            position: relative;
            color: #ffffff;
            .card-text {
              display: inline-block;
              margin-top: 0.4rem;
              font-family: Roboto;
              font-style: normal;
              font-weight: 500;
              line-height: 1.27;
            }
            .card-time {
              display: inline-block;
              margin-top: 0.4rem;
              font-family: Open Sans;
              font-style: normal;
              font-weight: 300;
              line-height: 1.35;
              text-align: right;
              opacity: 0.7;
            }
          }
          &:nth-child(3) {
            width: 15.1vw;
            z-index: 8;
            right: 36%;
            top: 30%;
            animation-name: cardThird;
            .card-image-block {
              .card-category {
                font-size: 0.729vw;
              }
            }
            .card-text-block {
              .card-text {
                font-size: 0.93vw;
              }
              .card-time {
                font-size: 0.729vw;
              }
            }
          }
          &:nth-child(2) {
            filter: blur(2px);
            width: 13.4vw;
            top: 85%;
            right: 65%;
            z-index: 2;
            animation-name: cardSecond;
            .card-image-block {
              .card-category {
                font-size: 0.625vw;
              }
            }
            .card-text-block {
              .card-text {
                font-size: 0.83vw;
              }
              .card-time {
                font-size: 0.677vw;
              }
            }
          }
          &:nth-child(1) {
            filter: blur(1px);
            width: 12.8vw;
            top: 20%;
            right: 57%;
            z-index: 2;
            animation-name: cardFirst;
            .card-image-block {
              .card-category {
                font-size: 0.625vw;
              }
            }
            .card-text-block {
              .card-text {
                font-size: 0.78vw;
              }
              .card-time {
                font-size: 0.625vw;
              }
            }
          }
        }
        .journalist-decor-block {
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          align-items: center;
          margin-top: 24%;
          .journalist-decor {
            position: absolute;
            right: 0;
            &:nth-child(1) {
              width: 37.1vw;
              z-index: 1;
            }
            &:nth-child(2) {
              width: 36.6vw;
              z-index: 3;
            }
            &:nth-child(3) {
              width: 33.28vw;
              z-index: 5;
            }
            &:nth-child(4) {
              width: 30.5vw;
              z-index: 7;
            }
          }
        }
      }
    }
    .colleagues-block {
      position: absolute;
      width: 100%;
      height: 25vw;
      display: flex;
      transition: all 1.5s;
      .colleagues-left {
        position: relative;
        width: 45%;
        .collegues-decor {
          position: absolute;
          &:nth-child(1) {
            width: 37vw;
            height: 24.6vw;
            left: 11vw;
            z-index: 1;
          }
          &:nth-child(2) {
            width: 19.5vw;
            height: 13vw;
            z-index: 5;
            left: 11vw;
            top: 5vw;
          }
          &:nth-child(3) {
            width: 23vw;
            height: 23vw;
            z-index: 7;
            left: 0;
            top: 16vw;
          }
          &:nth-child(4) {
            width: 30.7vw;
            height: 30.7vw;
            z-index: 3;
            top: 5vw;
            left: 3vw;
          }
          &:nth-child(5) {
            width: 26vw;
            height: 26vw;
            z-index: 4;
            top: 3.75vw;
            left: 6.35vw;
          }
          &:nth-child(6) {
            width: 21.6vw;
            height: 21.6vw;
            z-index: 6;
            top: 13.5vw;
            left: 4.5vw;
          }
        }
      }
      .colleagues-right {
        position: relative;
        width: 55%;
        margin: auto 0;
        .colleagues-right-text {
          position: relative;
          display: block;
          color: #98a2b7;
          &:nth-child(1) {
            text-align: center;
            font-size: 4.68vw;
            line-height: 1.35;
            font-family: "Open Sans";
            font-style: normal;
            font-weight: 600;
          }
          &:nth-child(2) {
            font-family: "Playfair Display SC";
            font-style: normal;
            font-weight: bold;
            font-size: 3.9vw;
            line-height: 1.25;
            margin-left: 5vw;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1300px) {
  .staffPage {
    .staff-block {
      .btn-next {
        cursor: pointer;
        top: 36vw;
        right: 5vw;
        width: 10vw;
        height: 10vw;
        .btn-arrow {
          width: 80%;
          height: 80%;
        }
        .btn-letter-block {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          animation-duration: 5s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          &:nth-child(1) {
            animation-name: topBtnBlockLetter;
          }
          &:nth-child(3) {
            animation-name: bottomBtnBlockLetter;
          }
        }
        .btn-letter {
          position: absolute;
          left: 50%;
          bottom: 50%;
          width: 0;
          transform-origin: 0 100%;
          padding-bottom: 4.4vw;
          color: #c2b5a0;
          font-size: 1.5vw;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .staffPage {
    .staff-block {
      .btn-next {
        top: 80vw;
        right: 9%;
        width: 15vw;
        height: 15vw;
        .btn-letter {
          font-size: 2.5vw;
          padding-bottom: 6.5vw;
        }
      }

      .journalist-block {
        height: 65vw;

        .journalist-left {
          margin: 0;
          .journalist-left-text {
            &:nth-child(1) {
              font-size: 5.85vw;
            }
            &:nth-child(2) {
              font-size: 5.59vw;
            }
          }
        }
        .journalist-right {
          .journalist-card {
            &:nth-child(3) {
              width: 45vw;
              z-index: 6;
              top: 30%;
              animation-name: cardThird;
              .card-image-block {
                .card-category {
                  font-size: 2vw;
                }
              }
              .card-text-block {
                opacity: 0.6;
                .card-text {
                  font-size: 2.7vw;
                }
                .card-time {
                  font-size: 2vw;
                }
              }
            }
            &:nth-child(2) {
              width: 31vw;
              top: 65%;
              animation-name: cardSecond;
              .card-image-block {
                .card-category {
                  font-size: 1.43vw;
                }
              }
              .card-text-block {
                .card-text {
                  font-size: 2vw;
                }
                .card-time {
                  font-size: 1.2vw;
                }
              }
            }
            &:nth-child(1) {
              width: 30vw;
              top: 8%;
              animation-name: cardFirst;
              .card-image-block {
                .card-category {
                  font-size: 1.1vw;
                }
              }
              .card-text-block {
                .card-text {
                  font-size: 1.35vw;
                }
                .card-time {
                  font-size: 1.2vw;
                }
              }
            }
          }
          .journalist-decor-block {
            top: 27%;
            .journalist-decor {
              transform: translateX(50%);
              &:nth-child(1) {
                width: 118vw;
              }
              &:nth-child(2) {
                width: 112vw;
              }
              &:nth-child(3) {
                width: 98vw;
              }
              &:nth-child(4) {
                width: 83vw;
              }
            }
          }
        }
      }
      .colleagues-block {
        height: 65vw;
        .colleagues-left {
          width: 55%;
          .collegues-decor {
            &:nth-child(1) {
              width: 86vw;
              height: 58vw;
              left: -60%;
              top: -1vw;
            }
            &:nth-child(2) {
              width: 45.6vw;
              height: 30.1vw;
              z-index: 3;
              left: -20%;
              top: 16.8vw;
            }
            &:nth-child(3) {
              width: 55vw;
              height: 38vw;
              z-index: 5;
              left: 7.5vw;
              top: 35.7vw;
            }
            &:nth-child(4) {
              width: 55vw;
              height: 59vw;
              z-index: 1;
              top: 29vw;
              left: -23%;
            }
            &:nth-child(5) {
              width: 60vw;
              height: 60vw;
              z-index: 2;
              top: 12vw;
              left: -43%;
            }
            &:nth-child(6) {
              width: 49vw;
              height: 49vw;
              z-index: 4;
              top: 34vw;
              left: -60%;
            }
          }
        }
        .colleagues-right {
          position: relative;
          width: 45%;
          margin: 7% 0 0 0;
          .colleagues-right-text {
            &:nth-child(1) {
              font-size: 7vw;
            }
            &:nth-child(2) {
              font-size: 5.8vw;
              text-align: center;
              margin: 0;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .staffPage {
    .staff-block {
      .btn-next {
        top: 95vw;
        right: 10vw;
        .btn-arrow {
          width: 100%;
          height: 100%;
        }
        .btn-letter {
          font-size: 4.5vw;
          padding-bottom: 9.3vw;
        }
      }
      .journalist-block {
        height: 70vw;

        .journalist-left {
          width: 55%;
          .journalist-left-text {
            &:nth-child(1) {
              font-size: 8vw;
            }
            &:nth-child(2) {
              font-size: 6.5vw;
            }
          }
        }
        .journalist-right {
          width: 45%;
          .journalist-card {
            .card-text-block {
              .card-text {
                margin: 0;
              }
              .card-time {
                margin: 0;
              }
            }
            &:nth-child(3) {
              width: 55vw;
              top: 30%;
              .card-image-block {
                .card-category {
                  font-size: 2.3vw;
                }
              }
              .card-text-block {
                opacity: 0.6;
                .card-text {
                  font-size: 2.8vw;
                }
                .card-time {
                  font-size: 2.2vw;
                }
              }
            }
            &:nth-child(2) {
              width: 35vw;
              top: 80%;
              animation-name: cardSecond;
              .card-image-block {
                .card-category {
                  font-size: 1.43vw;
                }
              }
              .card-text-block {
                .card-text {
                  font-size: 2vw;
                }
                .card-time {
                  font-size: 1.2vw;
                }
              }
            }
            &:nth-child(1) {
              width: 30vw;
              top: 0;
              animation-name: cardFirst;
              .card-image-block {
                .card-category {
                  font-size: 1.1vw;
                }
              }
              .card-text-block {
                .card-text {
                  font-size: 1.35vw;
                }
                .card-time {
                  font-size: 1.2vw;
                }
              }
            }
          }
          .journalist-decor-block {
            top: 20%;
          }
        }
      }
      .colleagues-block {
        height: 70vw;
        .colleagues-left {
          .collegues-decor {
            &:nth-child(1) {
              left: -68%;
            }
          }
        }
        .colleagues-right {
          .colleagues-right-text {
            right: 4vw;
            &:nth-child(1) {
              font-size: 8vw;
              text-align: center;
            }
            &:nth-child(2) {
              font-size: 6vw;
              text-align: center;
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>
